/* eslint-disable @typescript-eslint/no-empty-function */
import { Component } from '@angular/core';
import { ClientSaleService } from './client-sale.service';

@Component({
  selector: 'pg-client-sale',
  templateUrl: './client-sale.component.html'
})
export class ClientSaleComponent {
  select = {
    client: {
      type: 'single',
      openDialog: false,
      id: null
    }
  };
  openClientCreate = false;
  clientCard = null;

  constructor(private clientSaleService: ClientSaleService) {}

  ngOnInit() {
    this.setClientServiceInCard();
  }

  onSelectedClient(client) {
    this.clientSaleService.setData(client);
    this.setClientServiceInCard();
    this.select.client.openDialog = false;
  }

  setClientDefault() {
    this.clientSaleService.setDataDefault();
    this.setClientServiceInCard();
  }

  setClientServiceInCard() {
    const client = this.clientSaleService.getData();
    const fieldsClient = {
      name: 'Nombre',
      identifier: 'Tipo de Documento',
      idNumber: 'Número de Documento',
      address: 'Dirección',
      groupLoyaltyId: 'Grupo de Lealtad',
      email: 'Email',
      phone: 'Teléfono'
    };
    this.clientCard = Object.keys(fieldsClient).map((key) => {
      const label = fieldsClient[key];
      try {
        const value = client[key];
        return { label, value };
      } catch (e) {
        return { label, value: '-' };
      }
    });
  }
}
